import React, {PropTypes} from 'react';
import {GridList} from 'material-ui/GridList';
import config from 'config';
import RaisedButton from 'material-ui/RaisedButton';
import {ImageListItemImage, ImageListContentItem} from '../../../api/club-cms/content/image-list.content';
import {AListContentComponent} from './AbstractListComponent';
import {ListItemEditReduxForm} from './ListContentComponent/ListItemEditForm';
import SimpleReactSortableComponent from '../DragItems/DraggableItem/SimpleReactSortableComponent';
import {StudioItem} from '../DragItems/DraggableItem/StudioItem'

export class ImageListContentComponent extends AListContentComponent {
  static contextTypes = {
    muiTheme: PropTypes.object.isRequired
  };

  createNewItem(data) {
    return new ImageListContentItem({
      ...data,
      details: data.details.toParams()
    });
  }

  moveItem = this.moveItem.bind(this);
  editItem = this.displayEditProfile.bind(this);
  deleteItem = this.deleteItem.bind(this);
  renderOverlay = this.renderOverlay.bind(this);
  getThemeColor = this.getThemeColor.bind(this);

  moveItem(dragIndex, hoverIndex) {
    const {node, onChange} = this.props;
    onChange(node.move(dragIndex, hoverIndex));
  }

  getThemeColor(){
    const {secondaryTextColor} = this.context.muiTheme.flatButton;
    return secondaryTextColor;
  }

  renderOverlay() {
    return (
      <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          height: '100%',
          width: '100%',
          zIndex: 1,
          opacity: 0.3,
          backgroundColor: this.getThemeColor()
        }}/>
    );
  }


  render() {
    const {open, editInitialValues}  = this.state;
    const {node = {items: []}} = this.props;
    
    return (
      <div>
        <GridList
          cellHeight={180}
          cols={1}
          padding={20}
          style={{margin: 0, width:'50%'}}
        >
          {node.items.map((item, index) => (
            <div key={index} style={{height: '156px'}}>
              <SimpleReactSortableComponent
                index={index}
                id={`${index}`}
                node={item}
                moveItem={this.moveItem}
                renderOverlay={this.renderOverlay}>
                <StudioItem
                  item={item}
                  index={index}
                  id={index}
                  editItem={this.editItem}
                  deleteItem={this.deleteItem}
                  color={this.getThemeColor()}
                />
              </SimpleReactSortableComponent>
            </div>
          ))}
        </GridList>
        <div style={{padding: 30}}>
          <RaisedButton label="Add" onClick={() => this.showAdd()}/>
        </div>
        <ListItemEditReduxForm open={open}
                               ImageClass={ImageListItemImage}
                               imageCrop={config.clubCms.imageListCrop}
                               initialValues={editInitialValues}
                               onSave={(data) => this.saveProfile(data)}
                               onClose={() => this.closeEditProfile()}
        />
      </div>
    );
  }
}

export default ImageListContentComponent;



// WEBPACK FOOTER //
// ./src/components/ClubCMS/Content/ImageListContentComponent.js